<ul class="header-user">
  <li class="header-user__item eye-d-none">
    <button class="user-button eye-toggle" (click)="eyeService.enable()">
      <span class="eye-toggle__text align-top">{{
        'EYE_SIGHT' | translate
      }}</span>
      <fa-icon [icon]="faGlasses" class="eye-toggle__icon"></fa-icon>
    </button>
  </li>
  <li class="header-user__item">
    <app-lang-selector></app-lang-selector>
  </li>
  @if (session) {
    <li
      class="header-user__item position-relative"
      dropdown
      #dropdown="bs-dropdown"
      (mouseenter)="dropdown.show()"
      (mouseleave)="dropdown.hide()"
    >
      <a
        class="user-button user-button--transparent d-block"
        [routerLink]="['/personal'] | localize"
      >
        <div
          class="user-button__icon"
          [inlineSVG]="'../assets/img/icons/account.svg'"
        ></div>
        @if (notificationsCounter$ | async) {
          <app-notification-counter [counterValiant]="'small'">
          </app-notification-counter>
        }
        @if (isIndividual) {
          <span class="user-button__text">
            {{ session.phone }}
          </span>
        } @else {
          <span class="user-button__text">
            {{ session.email || session.phone }}
          </span>
        }
        <button
          type="button"
          dropdownToggle
          stopPropagation
          (click)="$event.preventDefault(); dropdown.triggers = ''"
        >
          <fa-icon
            [icon]="faChevronDown"
            class="header-chevron header-user__chevron"
            [class.rotate-180]="dropdown.isOpen"
            [fixedWidth]="true"
          ></fa-icon>
        </button>
      </a>
      <ul
        *dropdownMenu
        class="header-user__dropdown header-dropdown shadow"
        role="menu"
        (mouseleave)="dropdown.hide()"
      >
        <li role="menuitem">
          <a class="pointer" (click)="logout()">{{ 'LOGOUT' | translate }}</a>
        </li>
      </ul>
    </li>
  } @else {
    <li>
      <button
        class="user-button user-button--transparent eye-hover"
        type="button"
        (click)="onOpenLogin()"
      >
        <div
          class="user-button__icon"
          [inlineSVG]="'../assets/img/icons/account.svg'"
        ></div>
        <span>{{ 'LOG_IN' | translate }}</span>
      </button>
    </li>
  }
</ul>
